export enum EventType {
  'BATCH_EXPLORE_CLICK' = 'k8_batch_explore_click',
  'RECENT_VIDEO_CLICK' = 'k8_recent_video_click',
  'INTERACTIVE_VIDEO_CLICK' = 'k8_interactive_video_click',
  'MYBATCH_NAVIGATION' = 'k8_mybatch_navigation',
  'TEACHER_PROFILE' = 'k8_teacher_profile',
  'WEEKLY_SCHEDULE_CLICK' = 'k8_weekly_schedule_click',
  'START_CLASS' = 'k8_start_class',
  'CLASSESS_CLICK' = 'k8_classes_click',
  'CLASS_CONTENT_EXPLORE' = 'k8_class_content_explore',
  'STUDYROOM_SUBJECT' = 'k8_studyroom_subject',
  'STUDYROOM_CHAPTER' = 'k8_studyroom_chapter',
  'BATCHLETSSTUDY' = 'k8_batch_lets_study',
  'PRACTICE_CLICK' = 'k8_practice_click',
  'ASSIGNMENT_CLICK' = 'k8_assignment_click',
  'BATCH_PREVIEW_VIDEO' = 'k8_batch_preview_video',
  'BATCH_BUYNOW' = 'k8_batch_buynow',
  'BATCH_PAYNOW' = 'k8_batch_paynow',
  'TRANSACTION_SUCCESS' = 'k8_transaction_success',
  'K8_CHAPTER_NAVIGATION' = 'k8_chapter_navigation',
  'K8_ENROLLED' = 'k8_enrolled',
  'ASK_DOUBT_CLICKED' = 'ask_doubt_clicked',
  'MY_DOUBTS_SECTION_CLICKED' = 'my_doubts_section_clicked',
  'ACADEMIC_DOUBT_ACT' = 'academic_doubt_act',
  'DOUBT_ASK' = 'doubt_ask',
  'STREAMING_OFF' = 'streaming_off',
  'SCHEDULE_UPDATE' = 'schedule_update',
  'DE_DOUBT_ASK' = 'de_doubt_ask',
  'DE_NOTIFICATION_RECEIVE' = 'de_notification_receive',
  'DE_NOTIFICATION_OPEN' = 'de_notification_open',
  'DE_MYDOUBT_SELECT' = 'de_mydoubt_select',

  // Centre-page
  'CENTRE_PAGE_VISIT' = 'centre_page_visit',
  'BANNER_CLICK' = 'centre_banner_click',
  'CENTRE_SEARCH' = 'centre_search',
  'LISTING_VISIT' = 'centre_listing_visit',
  'CITY_CLICK' = 'centre_city_click',
  'CONTACT_US_CLICK' = 'centre_call_button',
  'CENTRE_REQUEST' = 'centre_request',
  'COURSE_TAB_CLICK' = 'centre_course_tabs',
  'EXPLORE_CENTRES' = 'centre_explore_centres',
  'CENTRE_EXPLORE' = 'centre_explore',
  'CENTRE_NAVIGATION' = 'centre_navigation',
  'CENTRE_EXAM_NAVIGATION' = 'centre_exam_navigation',
  'CENTRE_BATCH_EXPLORE' = 'centre_batch_explore',
  'CENTRE_BATCH_BOOK_SEAT' = 'centre_batch_book_seat',
  'CENTRE_ENQUIRE' = 'centre_enquire',
  'CENTRE_EXP_VIDEO' = 'centre_exp_video',

  'MARKETPLACE_VISIT' = 'marketplace_visit',
  'SEARCH_QUERY' = 'search_query',
  'TEST_FILTER' = 'test_filter',
  'TEST_EXPLORE' = 'test_explore',
  'CONTINUE_MODE' = 'continue_mode',
  'CHANGE_MODE_CLICK' = 'change_mode_click',
  'TEST_MODE_VIDEO' = 'test_mode_video',
  'SEE_SCHEDULE' = 'see_schedule',
  'TEST_SERIES_FAQ' = 'test_series_faq',
  'BUY_NOW_CLICKED' = 'buy_now_clicked',
  'PROCEED_TO_PAYMENT' = 'proceed_to_payment',
  'TRANSACTION_FAILED_PW' = 'transaction_failed',
  'TRANSACTION_SUCCESS_PW' = 'transaction_success',
  'ORDER_CONTINUE' = 'order_continue',

  // Test engine
  'TEST_CARD_CLICK' = 'test_card_click',
  'START_TEST' = 'start_test',
  'TEST_SUBMIT' = 'test_submit',
  'TEST_VIEW_SOLUTION' = 'test_view_solution',
  'TEST_VIDEO_SOLUTION' = 'test_video_solution',
  'TEST_REATTEMPT' = 'test_reattempt',

  // Mentorship  //   Vidyapeeth Webinar
  'LISTING_PAGE_VISIT' = 'listing_page_visit',
  'EXPLORE_CLICK' = 'explore_click',
  'CTA_CLICK' = 'cta_click',
  'CONFIRM_CLICK' = 'confirm_click',
  'REGISTER_CLICK' = 'register_click',
  'REGISTER_CONFIRMATION' = 'register_confirmation',
  'REGISTER_CLICK_PROCEED' = 'register_click_proceed',
  'REGISTER_OTP_VERIFY' = 'register_otp_verify',
  'NEED_HELP' = 'need_help',
  'NEED_HELP_ACTION' = 'need_help_action',
  'JOIN_NOW' = 'join_now',
  'CALL_CTA_CLICK' = 'call_cta_click',

  // GA-EVENTS
  'VIDEO_PLAYER_FEATURE' = 'video_player_feature',
  'TIMELINE_SLIDE_SELECT' = 'timeline_slide_select',
  'POLL_ICON_CLICKED' = 'poll_icon_clicked',
  'POLL_STATUS_CHANGED' = 'poll_status_changed',
  'POLL_EVENT_RECEIVED' = 'poll_event_received',
  'POLL_ID3_EVENT_RECEIVED' = 'poll_id3_event_received',
  'VIDEO_PLAYER_USED' = 'video_player_used',
  'MQTT_CONNECTION_STATE' = 'mqtt_connection_state',
  'U_SOCKET_CONECTION_STATE' = 'u_socket_connection_state',

  // saarthi-cwoc
  'VIDEO_CALL_CLICK' = 'video_call_click',
  'CWOC_IMAGE' = 'cwoc_image',
  'NOTIFY_CLICK' = 'notify_click',
  'your_coach_click' = 'your_coach_click',
  'other_coach_click' = 'other_coach_click',
  'popup_close' = 'popup_close',

  // 100MS-events
  'HUNDRED_MS_INVITE_RECEIVED' = 'hundred_ms_invite_received',
  'HUNDRED_MS_INVITE_ACCEPTED' = 'hundred_ms_invite_accepted',
  'HUNDRED_MS_INVITE_REJECTED' = 'hundred_ms_invite_rejected',
  'HUNDRED_MS_CALL_ENDED' = 'hundred_ms_call_ended',
  'HUNDRED_MS_INVITE_ACCEPTED_USING_ICON' = 'hundred_ms_invite_accepted_using_icon',
  'HUNDRED_MS_CAMERA_CLOSED' = 'hundred_ms_camera_closed',
  'HUNDRED_MS_CAMERA_OPEN' = 'hundred_ms_camera_open',
  'HUNDRED_MS_MICROPHONE_CLOSED' = 'hundred_ms_microphone_closed',
  'HUNDRED_MS_MICROPHONE_OPEN' = 'hundred_ms_microphone_open',

  // 3D Model Events
  'THREE_D_MODEL_ZOOMED_OUT' = 'three_d_model_zoomed_out',
  'THREE_D_MODEL_ZOOMED_IN' = 'three_d_model_zoomed_in',
  'THREE_D_MODEL_MAXIMIZED' = 'three_d_model_maximized',
  'THREE_D_MODEL_OPEN' = 'three_d_model_open',
  'THREE_D_LIST_OPEN' = 'three_d_list_open',

  // POLLS events
  'POLL_RECEIVED' = 'poll_received',

  // Live class events
  'LIVE_CLASS_JOINED' = 'live_class_joined',
  'LIVE_CLASS_LEFT' = 'live_class_left',

  // Note Making
  'NOTES_REDIRECTION_CLICK' = 'notes_redirection_click',

  // ASK_SAARTHI
  'MESSAGE_SENT' = 'message_sent',

  // LOW_DATA_MODE
  'LDM_FEEDBACK_POPUP' = 'ldm_feedback_popup',
  'LDM_FEEDBACK_SUBMIT' = 'ldm_feedback_submit',
  'LDM_COACHMARK' = 'ldm_coachmark',
  'LDM_TOGGLE' = 'ldm_toggle',
  'LDM_PIP_STATE' = 'ldm_pip_state',
  'LDM_UNSTABLE_INTERNET_POPUP' = 'ldm_unstable_internet_popup',
  'LDM_UNSTABLE_INTERNET_POPUP_CTA' = 'ldm_unstable_internet_popup_cta',
  'LDM_MEDIA_ERROR' = 'ldm_media_error',

  // CONVIVA
  'PW_PLAYER_LOAD' = 'pw_player_load',
  'PW_CONVIVA_TRACKING_INITIALIZED' = 'pw_conviva_tracking_initialized',
  'PW_SIGNED_COOKIE' = 'pw_signed_cookie',
  'PW_VIDEO_PLAYABLE' = 'pw_video_playable',
  'FIRST_TIME_VIDEO_PLAY' = 'firsttime_video_play',
  'VIDEO_URL_UNIFICATION' = 'video_url_unification',

  // LIVE POLL AND POST POLL FEEDBACK
  'POLL_FEEDBACK_SUBMIT' = 'poll_feedback_submit',
  'POLL_SUBMIT' = 'poll_submit',
  'POLL_OPEN' = 'poll_open',
  'POLL_CLICK' = 'poll_click',
  'POLL_ACTION' = 'poll_action',

  // SINGLE SCHEDULING EVENTS
  'SINGLE_SCHEDULING_CARD_CLICK' = 'single_scheduling_card_click',
  'SINGLE_SCHEDULING_ATTACHMENT_POP' = 'single_scheduling_attachment_popup',
  'VIDEO_PLAYER_CLICK' = 'video_player_click',
  'VIDEO_SAVE_CLICK' = 'video_save_click',
  'PW_VIDEO_PLAYER_SUBMIT_CLICK' = 'pw_video_player_submit_click',

  // VERNACULAR EVENTS
  'LANGUAGE_CHANGE' = 'language_change',

  // SETTINGS EVENTS
  'SETTING_SELECTION' = 'setting_selection',

  // periodic sync
  'PERIODIC_SYNC' = 'periodic_sync',

  // lecture leaving
  'BACK_BUTTON_CLICK' = 'back_button_click',
  'POPUP_SHOWN' = 'popup_shown',
  'POPUP_CLICK' = 'popup_click',
  'FEEDBACK_POPUP_CLICK' = 'feedback_popup_click',
  'LECTURE_RATING_POPUP_SHOWN' = 'lecture_rating_popup_shown',
  'LECTURE_RATING_POPUP_CLOSED' = 'lecture_rating_popup_closed',
  'LECTURE_RATING_SUBMITTED' = 'lecture_rating_submitted',
  'LECTURE_RATING_CLICKED' = 'lecture_rating_clicked',

  // PPJ
  'VIDEO_COMPLETION_TOGGLE' = 'video_completion_toggle',

  // DPP
  'DPP_CARD_CLICK' = 'dpp_card_click',

  // LEARN 2 EARN
  'LEARN_2_EARN_PROFILE_CLICK' = 'learn_2_earn_profile_click',

  // Video Copilot
  'VIDEO_COPILOT_CLICK' = 'copilot_click',
  'VIDEO_COPILOT_INTERACTIONS' = 'copilot_interactions',
  'VIDEO_COPILOT_CONVERSATION_RESPONSE' = 'copilot_conversation_response',
}
export interface PwEvent {
  type: EventType;
}
